// RequestDetailDialog.approvalFlow.js
// peer 拍 #19 捷点 3: RequestDetailDialog approve handler 把行 type 透传给 hook (approvalRequest 4th arg).
// 提取到模块级 + 纯函数化, 允许单测.
//
// 关键风险: line 739 (else 分支) 调 approvalRequest(approvalId, 'approved', null, get(data, 'type')),
// type 透传必须保留. 旧 IB 升级走 line 698-708 (ibApplication 分支, 带完整 ibCode/level/sale 参数),
// 渠道申请走 line 735-740 (else 分支, 最小参数, type 透传).
//   - 若有人误把 else 改成调 approvalWithdrawal, 端点降级为 workflow/withdrawal, ibChannel 路径炸
//   - 若有人误把 line 739 第 4 参从 `get(data, 'type')` 改成硬编码 'ibApplication',
//     渠道行被识别为旧 IB 升级, 走 workflow/ib, 端点分流失败
//
// 单测断言 (peer 拍 "提就测, 提不出来就报残余风险"):
//   1. type='ibChannel' → flow=OTHER_DEFAULT, typeArg='ibChannel' (透传, **不被硬编码为 ibApplication**)
//   2. type='ibApplication' → flow=IB_APPLICATION_FULL, typeArg='ibApplication' (走完整 IB 升级参数)
//   3. type='withdrawal' + subType!='DebitCard' → flow=WITHDRAWAL (走 approvalWithdrawal, typeArg=null)
//   4. type='withdrawal' + subType='DebitCard' → flow=CARD_TOPUP (走 approvalCardTopup, typeArg=null)
//   5. type='account' → flow=FX_ACCOUNT
//   6. type='Account' + subType='DebitCard' → flow=CARD
//   7. type='exchangeWithdrawal' → flow=WALLET
//
// 纯函数: 不依赖 approvalRequest/approvalWithdrawal/... 等. 调用方按 flow 派发副作用.

export const APPROVAL_FLOW = {
    IB_APPLICATION_FULL: 'ibApplicationFull',
    WITHDRAWAL: 'withdrawal',
    FX_ACCOUNT: 'fxAccount',
    WALLET: 'wallet',
    CARD: 'card',
    CARD_TOPUP: 'cardTopup',
    OTHER_DEFAULT: 'otherDefault',
};

/**
 * 决定 admin 弹窗 approve 走哪个分支, 透传 type 给 approvalRequest.
 *
 * @param {object} args
 * @param {string} args.type — 行 type (processRequestList 映射后的前端标识, e.g. 'ibChannel', 'ibApplication')
 * @param {string} [args.subType] — 行 subType (e.g. 'DebitCard')
 * @returns {{flow: string, typeArg: string|null}}
 */
export function decideApprovalFlow({type, subType}) {
    if (type === 'ibApplication') {
        // 旧 IB 升级: 走完整 IB 升级参数 (ibCode/level/sale/levels[0].id)
        return { flow: APPROVAL_FLOW.IB_APPLICATION_FULL, typeArg: 'ibApplication' };
    }
    if (type === 'withdrawal' && subType === 'DebitCard') {
        return { flow: APPROVAL_FLOW.CARD_TOPUP, typeArg: null };
    }
    if (type === 'withdrawal') {
        return { flow: APPROVAL_FLOW.WITHDRAWAL, typeArg: null };
    }
    if (type === 'account') {
        return { flow: APPROVAL_FLOW.FX_ACCOUNT, typeArg: null };
    }
    if (type === 'Account' && subType === 'DebitCard') {
        return { flow: APPROVAL_FLOW.CARD, typeArg: null };
    }
    if (type === 'exchangeWithdrawal') {
        return { flow: APPROVAL_FLOW.WALLET, typeArg: null };
    }
    // 兜底: 透传 type 给 approvalRequest. ibChannel 走这里.
    //   - 调用方: approvalRequest(approvalId, 'approved', null, typeArg) → useTasks.js:535 端点 = 'workflow/ib-channel' (type='ibChannel')
    //   - 风险点: typeArg 必须 === 传入的 type, 不能被硬编码成 'ibApplication'
    return { flow: APPROVAL_FLOW.OTHER_DEFAULT, typeArg: type };
}
